import { render, staticRenderFns } from "./detail-sel.vue?vue&type=template&id=6ad030dc&scoped=true"
import script from "./detail-sel.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-sel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-sel.vue?vue&type=style&index=0&id=6ad030dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad030dc",
  null
  
)

export default component.exports